module.exports = __webpack_public_path__ + "img/ctrl-bwecp-stub-mid--.e6fa0de3.svg";